import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { SeatBookingContainerStyled } from "./styled";
import { portalService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Buttons, Displays } from "components";
import BookingTab from "./Tabs/BookingTab";
import SeatTab from "./Tabs/SeatTab";
import SettingTab from "./Tabs/SettingTab";
import CheckInTab from "./Tabs/CheckInTab";

// หน้าจัดการกิจกรรมจองที่นั่ง แยกจากหน้าผู้เข้าร่วมเดิม (ActivityOfflineDetailContainer) เพื่อไม่กระทบกิจกรรมอื่น
// แท็บเก็บใน ?tab= กดรีเฟรช/แชร์ลิงก์แล้วกลับมาแท็บเดิม
const TABS = [
  { key: "booking", label: "ผู้เข้าร่วม / ตรวจสลิป" },
  { key: "seat", label: "ที่นั่ง" },
  { key: "checkin", label: "เข้างาน" },
  { key: "setting", label: "ตั้งค่า" },
];

const SeatBookingContainer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = TABS.some((t) => t.key === searchParams.get("tab"))
    ? searchParams.get("tab")
    : "booking";

  const authenRedux = useSelector((state) => state.authenRedux);
  const permission =
    authenRedux &&
    authenRedux.permission &&
    authenRedux.permission.find((e) => e.menu_key === "activity");
  // อนุมัติ/ปฏิเสธ/จองให้ ผูกกับสิทธิ์แก้ไขของเมนู Activity เหมือนหน้าผู้เข้าร่วมเดิม
  const canUpdate = !!(permission && permission.is_update);

  const [_isLoading, _setIsLoading] = useState(true);
  const [_activity, _setActivity] = useState();
  const [_config, _setConfig] = useState();

  const _fetchConfig = useCallback(async () => {
    const res = await portalService.GET_SEAT_BOOKING_CONFIG(id);
    if (res && res.status === 200) _setConfig(res.data);
  }, [id]);

  useEffect(() => {
    const fetchData = async () => {
      const [resActivity] = await Promise.all([
        portalService.GET_ACTIVITY_DETAIL(id),
        _fetchConfig(),
      ]);
      if (resActivity && resActivity.status === 200) _setActivity(resActivity.data);
      _setIsLoading(false);
    };
    fetchData();
  }, [id, _fetchConfig]);

  const schools = (_config && _config.config && _config.config.schools) || [];

  return (
    <SeatBookingContainerStyled>
      {_isLoading ? (
        <Displays.Loading theme_standard_loading />
      ) : !_activity || !_activity.is_seat_booking ? (
        <div className="empty_block">
          กิจกรรมนี้ไม่ได้เปิด Booking Seat (เปิดได้ที่หน้าแก้ไขกิจกรรม ประเภท Offline)
        </div>
      ) : (
        <>
          <div className="header_row">
            <div>
              <div className="title">Booking Seat · {_activity.name_th}</div>
              <div className="sub_title">
                {_activity.code}
                {_activity.is_unlisted ? " · ซ่อนจากหน้ารวม (เข้าได้ทางลิงก์)" : ""}
                {_activity.is_active ? " · Active" : " · ไม่ Active"}
                {_config && _config.gate_problems && _config.gate_problems.length
                  ? " · ตั้งค่ายังไม่ครบ"
                  : " · ตั้งค่าครบ (เปิดจองตามช่วงลงทะเบียน)"}
              </div>
            </div>
            <div className="header_btns">
              <div className="w140">
                <Buttons.BgStandard
                  theme_gray
                  label="แก้ไขกิจกรรม"
                  onClick={() => navigate(`${ROUTE_PATH.ACTIVITY}/${id}`)}
                />
              </div>
              <div className="w120">
                <Buttons.BgStandard
                  theme_gray
                  label="Back"
                  onClick={() => navigate(ROUTE_PATH.ACTIVITY)}
                />
              </div>
            </div>
          </div>
          <div className="tab_row">
            {TABS.map((t) => (
              <div
                key={t.key}
                className={`tab_item${tab === t.key ? " active" : ""}`}
                onClick={() => setSearchParams({ tab: t.key })}
              >
                {t.label}
              </div>
            ))}
          </div>
          {tab === "booking" && (
            <BookingTab activityId={id} schools={schools} canUpdate={canUpdate} />
          )}
          {tab === "seat" && (
            <SeatTab
              activityId={id}
              schools={schools}
              config={(_config && _config.config) || {}}
              canUpdate={canUpdate}
            />
          )}
          {tab === "checkin" && <CheckInTab activityId={id} canUpdate={canUpdate} />}
          {tab === "setting" && (
            <SettingTab
              activityId={id}
              activity={_activity}
              data={_config}
              canUpdate={canUpdate}
              onSaved={_fetchConfig}
            />
          )}
        </>
      )}
    </SeatBookingContainerStyled>
  );
};

export default SeatBookingContainer;
